module.exports = __webpack_public_path__ + "img/close.e2fcd63.png";